<template>
  <div class="nav-introduce px-[20px] pt-[10px] pb-[20px] bg-white rounded-sm mb-[10px]">
    <CruiseDetailCommenTitle class="mb-[10px]" :title="title" />
    <div :class="[textHeight > maxTextHeight && !showMore ? 'h-25 overflow-hidden' : '']">
      <div ref="textRef">
        <editor-content normal :content="content" />
      </div>
    </div>
    <div class="text-primary text-sm pt-2.5 cursor-pointer" v-if="textHeight >= maxTextHeight" @click="showMore = !showMore">
      <template v-if="!showMore">
        <span>更多{{ title }}信息</span>
        <i class="ficon ficon-arrow-bottom"></i>
      </template>
      <template v-else>
        <span>收起</span>
        <i class="ficon ficon-arrow-up"></i>
      </template>
    </div>
  </div>
</template>

<script>
  import {
    defineComponent,
    ref,
} from "@nuxtjs/composition-api";
import EditorContent from "~/components/Ckeditor/EditorContent.vue";
import CruiseDetailCommenTitle from "@/views/company/CruiseDetailCommenTitle.vue"
import { useElementSize } from "@vueuse/core";

export default defineComponent({ 
  name:'TextView',
  components:{
    EditorContent,
    CruiseDetailCommenTitle,
  },
  props:{
    content: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  setup(props){
    const textRef = ref(null);
    const { height: textHeight } = useElementSize(textRef);
    const showMore = ref(false);
    const maxTextHeight = ref(100)
    return {
      textRef,
      textHeight,
      showMore,
      maxTextHeight,
    }
  }
})
</script>

<style lang="scss" scoped>



</style>